import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { apiPost } from "./client";

/**
 * ikas kurulum uclari — /api/v2/ikas/* (backend/app/core/api/ikas.py).
 * `GET /install` bir 302 REDIRECT'tir (JSON donmez) — bu yuzden fetch ile
 * cagrilmaz; /kurulum sihirbazi `window.location.assign(installUrl(store))`
 * ile TAM SAYFA yonlendirme yapar (OAuth akisi ayni sekmede devam eder).
 */

export function installUrl(store: string): string {
  return `/api/v2/ikas/install?store=${encodeURIComponent(store)}`;
}

export const registerWebhooksResponseSchema = z.object({
  ok: z.boolean(),
  webhooks: z.unknown().optional(),
});
export type RegisterWebhooksResponse = z.infer<typeof registerWebhooksResponseSchema>;

export function registerWebhooksRequest(): Promise<RegisterWebhooksResponse> {
  return apiPost("/api/v2/ikas/register-webhooks", registerWebhooksResponseSchema);
}

export function useRegisterWebhooksMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: registerWebhooksRequest,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ["tenant", "settings"] }),
  });
}
